import { filter, ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import {
  getCurrentResourceSubUniverseName,
  getCurrentResourceUniverseName,
  getDaysSinceStartSale,
  getFilteredProductsInParentScope,
  getNbSubUniversesInCatalog,
  getNbUniversesInCatalog,
  getOperationCode,
  getProductCallPrice,
  getProductPriceValue,
  getProductSourceKey,
  getProductTitle,
  getSaleStartTime
} from 'store/selectors'
import { disableMixPanelTracking } from '../disable'

const hasOperationCode = (state) => () => (
  getOperationCode(state) !== ''
)

const mapStateToMPEvent = (eventName, state, actionType) => { // (eventName: string, state: State, actionType: Actions.modals.REJECTION_MODAL_CLICK_OFFERS | Actions.modals.REJECTION_MODAL_CLICK_CLOSE | Actions.modals.REJECTION_MODAL_APPEARANCE  )
  const nbUniverses = getNbUniversesInCatalog(state)

  const baseProperties = {
    '# of References': getFilteredProductsInParentScope(state)?.length ?? 0,
    '# of Sub Universes': getNbSubUniversesInCatalog(state),
    '# of Universes': getNbUniversesInCatalog(state),
    'Days Since Sale Start': getDaysSinceStartSale(state),
    'Event Name': eventName,
    'Lowest Price': getProductCallPrice(state),
    'Operation Code': getOperationCode(state),
    'Page Name': 'Unavailable Waiting Module Pop In',
    'Product': getProductTitle(state),
    'Product ID': getProductSourceKey(state),
    'Product Price': getProductPriceValue(state),
    'Sale Start Time': getSaleStartTime(state),
    'Under Universe': nbUniverses > 1 ? getCurrentResourceSubUniverseName(state) : '',
    'Universe': nbUniverses > 1 ? getCurrentResourceUniverseName(state) : ''
  }

  switch (actionType) {
    case (Actions.modals.REJECTION_MODAL_CLICK_OFFERS): {
      return {
        ...baseProperties,
        'Click Name': 'Click Discover Our Offers',
        'Interaction Type': 'Click'
      }
    }
    case (Actions.modals.REJECTION_MODAL_CLICK_CLOSE): {
      return {
        ...baseProperties,
        'Click Name': 'Click Exit Pop In',
        'Interaction Type': 'Click'
      }
    }
    case (Actions.modals.REJECTION_MODAL_APPEARANCE): {
      return {
        ...baseProperties,
        'Interaction Type': 'Page View'
      }
    }
  }
}

const rejectionModalEpic = (actions$, state$) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(
    Actions.modals.REJECTION_MODAL_APPEARANCE,
    Actions.modals.REJECTION_MODAL_CLICK_CLOSE,
    Actions.modals.REJECTION_MODAL_CLICK_OFFERS
  ),
  filter(hasOperationCode(state$.value)),
  tap((action) => { // (action: RejectionModalAppearanceAction | RejectionModalClickCloseAction | RejectionModalClickOffersAction)
    const eventName = action.type === Actions.modals.REJECTION_MODAL_APPEARANCE
      ? 'See Unavailable Waiting Module Pop In'
      : 'Click'

    track(eventName, mapStateToMPEvent(eventName, state$.value, action.type), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default rejectionModalEpic
